// extracted by mini-css-extract-plugin
export var infoItem = "_t1-2";
export var title = "_t1-0";
export var value = "_t1-1";